import type React from 'react';
import { forwardRef } from 'react';

export interface InputTextAreaProps
  extends Pick<
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    | 'name'
    | 'value'
    | 'readOnly'
    | 'placeholder'
    | 'disabled'
    | 'autoFocus'
    | 'maxLength'
    | 'rows'
    | 'onChange'
  > {
  state?: 'normal' | 'error';
}

export const InputTextArea = forwardRef<
  HTMLTextAreaElement,
  InputTextAreaProps
>(
  (
    {
      name,
      value,
      readOnly,
      placeholder,
      disabled,
      autoFocus,
      maxLength,
      rows,
      onChange,
      state = 'normal',
      ...props
    },
    ref
  ) => {
    return (
      <textarea
        ref={ref}
        className={`
      px-2.5 py-2
      rounded-md
      bg-white 
      resize-none 

      placeholder-ds-natural-300
      leading-ds-300
      tracking-ds-normal
      font-ds-inter
      font-ds-normal
      text-ds-400
      text-ds-natural-600

      box-border
      border-none
      outline
      !outline-1
      outline-offset-[-1px]
      focus:outline-offset-[-1px]
      focus:ring-0
      ${
        {
          normal:
            'outline-ds-natural-100 focus:outline-ds-primary-300 focus-within:outline-ds-primary-300',
          error:
            'outline-ds-danger-400 focus:outline-ds-danger-400 focus-within:outline-ds-danger-400',
        }[state]
      }

      disabled:bg-ds-natural-200-a
      disabled:text-ds-natural-200 
      disabled:outline-ds-natural-200
      `}
        name={name}
        rows={rows}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        readOnly={readOnly}
        disabled={disabled}
        autoFocus={autoFocus}
        maxLength={maxLength}
        autoComplete="off"
        {...props}
      />
    );
  }
);

InputTextArea.displayName = 'InputTextArea';
